// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__LcKJI","col":"styles_col__6sICu"};